<template>
  <div class="main-section-container">
    <div class="home">
      <RetailerNavBar :contact="this.contact" />
      <div class="container">
        <section class="collection-form has-text-left">
          <div v-if="!collection">
            <h1>Create a new Collection</h1>
            <form v-on:submit.prevent="createCollection">
              <b-field class="collection-name">
                <b-input
                  placeholder="Collection Name"
                  v-model="collectionName"
                ></b-input>
              </b-field>
              <button
                class="button is-success"
                :disabled="!collectionName"
                type="submit"
              >
                Next
              </button>
            </form>
          </div>

          <div v-else>
            <h1>
              Upload your Products in the {{ collection.name }} Collection
            </h1>
            <p>
              Please upload a CSV file with three columns; <b>Title</b>,
              <b>Description</b>, and <b>Image Link</b> (<a
                href="/RevShoppDemoTest.csv"
                >See an example</a
              >)
            </p>
            <div class="container">
              <div class="field">
                <div class="control">
                  <div class="file">
                    <label class="file-label">
                      <input
                        class="file-input"
                        type="file"
                        id="file"
                        ref="file"
                        @change="onFileChange"
                      />
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="fas fa-upload"></i>
                        </span>
                        <span class="file-label"> Select CSV </span>
                      </span>
                    </label>
                  </div>
                  <p class="help" v-if="file_name">
                    You Selected: <b>{{ file_name }}</b>
                  </p>
                </div>
              </div>
              <div class="actions">
                <button
                  class="button is-success"
                  :class="{ 'is-loading': isUploading }"
                  :disabled="!file"
                  @click="uploadFile"
                >
                  1. Upload
                </button>
                <button
                  class="button is-success"
                  :class="{ 'is-loading': isAnalyzing }"
                  :disabled="disableAnalysis()"
                  @click="analyzeCollection"
                >
                  2. Analyze
                </button>
                <button
                  class="button is-success"
                  :class="{ 'is-loading': isImporting }"
                  :disabled="!analysisComplete"
                  @click="importCollection"
                >
                  3. Import
                </button>
              </div>
            </div>
            <div v-if="previewData" class="data-preview">
              <b-table :data="previewData">
                <template slot-scope="props">
                  <b-table-column field="title" label="Title">
                    {{ props.row[0] }}
                  </b-table-column>
                  <b-table-column field="description" label="Description">
                    {{ props.row[1] }}
                  </b-table-column>
                  <b-table-column field="image" label="Image">
                    <img :src="props.row[2]" />
                  </b-table-column>
                  <b-table-column field="features" label="Features">
                    <div v-if="!props.row[3]">
                      <b-icon
                        pack="fas"
                        icon="question"
                        size="is-small"
                      ></b-icon>
                    </div>
                    <div v-else>
                      <b-icon pack="fas" icon="check" size="is-small"></b-icon>
                      <!-- {{ props.row[3] }} -->
                    </div>
                  </b-table-column>
                </template>
              </b-table>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import RetailerNavBar from "@/components/RetailerNavBar";
import Catalog from "@/services/catalog";

export default {
  name: "UploadCollection",
  components: {
    RetailerNavBar,
  },
  data: function () {
    return {
      file: null,
      file_name: null,
      isUploading: false,
      preview: false,
      upload: null,
      previewData: null,
      isAnalyzing: false,
      isProcessing: false,
      collectionName: null,
      collection: null,
      analysisComplete: false,
      isImporting: false,
      contact: null,
    };
  },
  mounted: function () {
    var contactId = localStorage.getItem("contactId");
    if (contactId) {
      Catalog.identifyContact(contactId).then((contact) => {
        this.contact = contact;
      });
    }
    this.$ga.page({
      page: "/",
      title: "Demo Create Collection",
    });
  },
  methods: {
    createCollection() {
      var self = this;
      return axios({
        method: "post",
        url: `api/collections/`,
        data: {
          name: self.collectionName,
          contact: self.contact ? self.contact.id : null,
        },
        responseType: "json",
      }).then(function (response) {
        self.collection = response.data;
        self.$ga.event({
          eventCategory: "collection",
          eventAction: "create",
          eventLabel: "Create Collection " + self.collection.name,
        });
      });
    },
    onFileChange(e) {
      this.previewData = null;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createFile(files[0]);
    },
    createFile(file) {
      var reader = new FileReader();
      var self = this;

      reader.onload = (e) => {
        self.file = e.target.result;
        self.file_name = file.name;
      };
      reader.readAsDataURL(file);
    },
    removeFile: function (e) {
      this.file = null;
    },
    uploadFile() {
      var self = this;
      self.isUploading = true;
      return axios({
        method: "post",
        url: `api/collections/${self.collection.id}/uploads/`,
        data: {
          upload: self.file,
          name: self.file_name,
        },
        responseType: "json",
      }).then(function (response) {
        self.isUploading = false;
        self.file = null;
        self.preview = true;
        self.upload = response.data;
        self.previewData = response.data.preview;
      });
    },
    analyzeCollection() {
      this.isAnalyzing = true;
      this.$toast.open({
        message: "Analyzing Products for Shape Intelligence Features",
        type: "is-success",
      });
      for (let i = 0; i < this.previewData.length; i++) {
        this.identify(this.previewData[i], i);
      }
      setTimeout(() => {
        this.analysisComplete = true;
        this.isAnalyzing = false;
      }, 1000);
    },
    identify(item, index) {
      var self = this;
      return axios({
        method: "post",
        url: `api/identify`,
        data: {
          text: item[0] + " " + item[1],
        },
        responseType: "json",
      }).then((response) => {
        self.previewData[index].push(response.data.features);
      });
    },
    importCollection() {
      this.$toast.open({
        message: "Scoring and Importing Products for Shape Intelligence",
        type: "is-success",
      });

      this.isImporting = true;
      var self = this;
      return axios({
        method: "post",
        url: `api/collections/${self.collection.id}/uploads/${self.upload.id}/process_upload`,
        responseType: "json",
      }).then((response) => {
        setTimeout(() => {
          self.isImporting = false;
          localStorage.setItem("collection-added", true);
          self.$router.push({
            name: "home",
            params: { collectionId: self.collection.id },
          });
        }, 100 * self.previewData.length);
      });
    },
    disableAnalysis() {
      if (!this.previewData || this.analysisComplete) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 2em;
}
section.collection-form {
  // border: 1px solid black;
  padding: 5%;
  .collection-name {
    width: 40%;
  }
  .file-cta {
    background-color: #8ec740;
    color: white;
    &:hover {
      background-color: #fd9fa3;
    }
  }
  .button.is-success {
    background-color: #8ec740;
    &:hover {
      background-color: #fd9fa3;
    }
  }
  div.container {
    margin-top: 5%;
  }
  .data-preview {
    margin-top: 1em;
    margin-bottom: 2em;
  }
}
div.actions {
  width: 50%;
  button {
    margin-right: 5%;
  }
}
</style>